import { useSuspenseQuery } from '@apollo/client';
import React from 'react';
import { useParams } from 'react-router-dom';

import { VStack } from '@eluve/components';
import { graphql } from '@eluve/graphql.tada';

import {
  PatientConditions,
  patientConditionsFragment,
} from './PatientConditions';
import {
  PatientLabResults,
  patientDiagnosticReportsFragment,
} from './PatientLabResults';

const patientArtifactsQuery = graphql(
  `
    query patientArtifacts($tenantId: uuid!, $patientId: uuid!) {
      patientsByPk(tenantId: $tenantId, id: $patientId) {
        __typename
        id
        observations {
          __typename
          id
          name
          referenceRange
          unit
          createdAt
        }
        ...PatientConditions
        ...PatientDiagnosticReports
      }
    }
  `,
  [patientConditionsFragment, patientDiagnosticReportsFragment],
);

export interface PatientArtifactsProps {}

export const PatientArtifacts: React.FC<PatientArtifactsProps> = () => {
  const { patientId, tenantId } = useParams() as {
    tenantId: string;
    patientId: string;
  };

  useSuspenseQuery(patientArtifactsQuery, {
    variables: {
      tenantId,
      patientId,
    },
  });

  return (
    <VStack gap={6} className="pt-2">
      <PatientConditions patientId={patientId} />
      <PatientLabResults patientId={patientId} />
    </VStack>
  );
};
